import isNil from 'lodash/isNil';
import strings from 'strings';
import { formatDurationFromSeconds } from 'UI/utils';

export const formatResponse = response => {
  const nestedData = response?.data?.data;
  const sourceData = Array.isArray(nestedData) ? nestedData : [];

  const formattedData = sourceData.map(item => ({
    ...item,
    industry: item?.industry && item?.specialty ? `${item?.industry}: ${item?.specialty}` : '',
    recruiterName: item?.user?.fullName || ''
  }));

  return { ...response, data: { ...response.data, data: formattedData } };
};

const FORMATTERS = {
  totalDurationSeconds: value => formatDurationFromSeconds(value),
  avgDurationSeconds: value => formatDurationFromSeconds(value)
};

export const formatStats = data => {
  const keyOrder = ['totalCalls', 'totalDurationSeconds', 'avgDurationSeconds'];

  const finalData = data?.data ?? data;

  const orderedData = keyOrder.reduce((acc, key) => {
    if (!isNil(finalData[key])) {
      acc[key] = finalData[key];
    }
    return acc;
  }, {});

  return Object.keys(orderedData).map(key => {
    const value = FORMATTERS[key] ? FORMATTERS[key](orderedData[key]) : finalData[key];
    return {
      title: strings.ai.generators.roleplay.metrics[key],
      value
    };
  });
};

export const buildPresentationMakerCandidateParam = candidateData => {
  if (!candidateData || !candidateData?.id) return {};

  return {
    candidate: {
      id: candidateData?.id,
      title: candidateData?.title,
      specialty: candidateData?.specialty,
      industry: candidateData?.industry
    }
  };
};

export const buildPresentationMakerJobOrderParam = jobOrderData => {
  if (!jobOrderData || !jobOrderData?.id) return {};

  return {
    jobOrder: {
      id: jobOrderData?.id,
      title: jobOrderData?.title,
      city: jobOrderData?.city,
      state: jobOrderData?.state
    }
  };
};
